import React, { Component } from 'react';
import WithConsumer from '../context/WithConsumer';
import CartModalQty from '../partials/CartModalQty';

const CartModal = ({ context }) => {
	
	const ctxCartOpen = () => context.cartOpen;
	const cartOpen = ctxCartOpen();
	
	const ctxCartStep = () => context.cartStep;
	const cartStep = ctxCartStep();
	
	const ctxUser = () => context.user;
	const user = ctxUser();
	
	const ctxOrderNotes = () => context.orderNotes;
	let orderNotes = ctxOrderNotes();
			
	if (user) {
	
		if (user.id == false || user.id == 'false' || user.id === null || user.id === -1) {
			
			return null;
			
		} else {
			
			if (user.cart.count) {
				if (user.cart.count === 0 && cartOpen === true && cartStep < 2) {
					context.toggleCart();
				}
			}
			
			if (cartOpen === false) {
				if (document.getElementsByClassName('c-cart__notes').length !== 0) {
					document.getElementsByClassName('c-cart__notes')[0].value = '';
				}
				if (document.getElementsByClassName('c-cart__delivery').length !== 0) {
					document.getElementsByClassName('c-cart__delivery')[0].value = '';
				}
			}
			
			const ctxCart = () => context.user.cart;
			const cart = ctxCart();
			
			let first_name = '';
			function FirstName() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__first-name').length !== 0) {
						if (user.first_name) {
							document.getElementsByClassName('c-cart__input__first-name')[0].value = user.first_name;
						} else if (user.first_name) {
							document.getElementsByClassName('c-cart__input__first-name')[0].value = user.first_name;
						}
					}
				}, 100);
				return (
					<input name="first_name" placeholder="First Name" type="text" className="c-cart__input__first-name" onChange={event => (first_name = event.target.value)} />
				)
			}
			
			let last_name = '';
			function LastName() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__last-name').length !== 0) {
						if (user.last_name) {
							document.getElementsByClassName('c-cart__input__last-name')[0].value = user.last_name;
						} else if (user.last_name) {
							document.getElementsByClassName('c-cart__input__last-name')[0].value = user.last_name;
						}
					}
				}, 100);
				return (
					<input name="last_name" placeholder="Last Name" type="text" className="c-cart__input__last-name" onChange={event => (last_name = event.target.value)} />
				)
			}
			
			let phone = '';
			function Phone() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__phone').length !== 0) {
						if (user.phone) {
							document.getElementsByClassName('c-cart__input__phone')[0].value = user.phone;
						} else if (user.phone) {
							document.getElementsByClassName('c-cart__input__phone')[0].value = user.phone;
						}
					}
				}, 100);
				return (
					<input name="phone" placeholder="Phone" type="text" className="c-cart__input__phone" onChange={event => (phone = event.target.value)} />
				)
			}
			
			let street_address = '';
			function StreetAddress() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__address').length !== 0) {
						if (user.ship_street_address) {
							document.getElementsByClassName('c-cart__input__address')[0].value = user.ship_street_address;
						} else if (user.street_address) {
							document.getElementsByClassName('c-cart__input__address')[0].value = user.street_address;
						}
					}
				}, 100);
				return (
					<input name="street_address" placeholder="Street Address" type="text" className="c-cart__input__address" onChange={event => (street_address = event.target.value)} />
				)
			}
			
			let city = '';
			function City() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__city').length !== 0) {
						if (user.ship_city) {
							document.getElementsByClassName('c-cart__input__city')[0].value = user.ship_city;
						} else if (user.city) {
							document.getElementsByClassName('c-cart__input__city')[0].value = user.city;
						}
					}
				}, 100);
				return (
					<input name="city" type="text" placeholder="City" className="c-cart__input__city" onChange={event => (city = event.target.value)} />
				)
			}
			
			let state = '';
			function State() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__state').length !== 0) {
						if (user.ship_state) {
							document.getElementsByClassName('c-cart__input__state')[0].value = user.ship_state;
						} else if (user.state) {
							document.getElementsByClassName('c-cart__input__state')[0].value = user.state;
						}
					}
				}, 100);
				return (
					<input name="state" type="text" placeholder="State" className="c-cart__input__state" onChange={event => (state = event.target.value)} />
				)
			}
			
			let postcode = '';
			function Postcode() {
				setTimeout(function(){
					if (document.getElementsByClassName('c-cart__input__postcode').length !== 0) {
						if (user.ship_postcode) {
							document.getElementsByClassName('c-cart__input__postcode')[0].value = user.ship_postcode;
						} else if (user.street_postcode) {
							document.getElementsByClassName('c-cart__input__postcode')[0].value = user.postcode;
						}
					}
				}, 100);
				return (
					<input name="postcode" type="text" placeholder="Postcode" className="c-cart__input__postcode" onChange={event => (postcode = event.target.value)} />
				)
			}
					
			function CartRows() {
				if (cart.items) {
					let _cartItem = '';
					
					return cart.items.map((item,i) =>
						<tr className="c-cart__item" key={i}>
							<td className="c-cart__item__cell">
								{item.srcset && 
									<div className="c-cart__item__cell__thumb">
										<img src={item.src} alt="" />
									</div>
								}
								<div className="c-cart__item__cell__header">
									{item.heading &&
										<h5 className="c-cart__item__cell__heading">{ item.heading }</h5>
									}
									{item.color &&
										<h5 className="c-cart__item__cell__subheading">{ item.color }</h5>
									}
								</div>
							</td>
							<td className="c-cart__item__cell">
								{item.price &&
									<p className="c-cart__item__cell__price">${ Intl.NumberFormat().format(item.price) }</p>	
								}
							</td>
							<td className="c-cart__item__cell">
								{item.qty &&
									<CartModalQty index={i}></CartModalQty>
								}
							</td>
							<td className="c-cart__item__cell">
								{item.price &&
									<p className="c-cart__item__cell__price">${ Intl.NumberFormat().format(item.price * item.qty) }</p>	
								}
							</td>
							<td className="c-cart__item__cell">
								<a href="#" data-index={i} onClick={event => removeFromCart(event)} className="c-cart__item__cell__remove">Remove</a>
							</td>
						</tr>
						
					);
				} else {
					return null;
				}
			}
			
			function submitOrder(event) {
				event.preventDefault();
							
				let submit = true;
				
				if (!document.getElementsByClassName('c-cart__input__first-name')[0].value) {
					document.getElementsByClassName('c-cart__input__first-name')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__first-name')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__last-name')[0].value) {
					document.getElementsByClassName('c-cart__input__last-name')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__last-name')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__phone')[0].value) {
					document.getElementsByClassName('c-cart__input__phone')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__phone')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__address')[0].value) {
					document.getElementsByClassName('c-cart__input__address')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__address')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__city')[0].value) {
					document.getElementsByClassName('c-cart__input__city')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__city')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__state')[0].value) {
					document.getElementsByClassName('c-cart__input__state')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__state')[0].classList.remove('state-error');
				}
				
				if (!document.getElementsByClassName('c-cart__input__postcode')[0].value) {
					document.getElementsByClassName('c-cart__input__postcode')[0].classList.add('state-error');
					submit = false;
				} else {
					document.getElementsByClassName('c-cart__input__postcode')[0].classList.remove('state-error');
				}
				
				if (submit === true) {
										
					context.submitOrder(user, first_name, last_name, phone, street_address, city, state, postcode, deliveryNotes, orderNotes);
				}
			}
			
			function toggleCart(event) {
				event.preventDefault();
				context.toggleCart();
			}
			
			function cartNext(event) {
				event.preventDefault();
				context.updateOrderNote(orderNotes);
				context.cartNext();
			}
			
			function cartPrev(event) {
				event.preventDefault();
				context.cartPrev();
			}
			
			function removeFromCart(event) {
				event.preventDefault();
				let _index = parseInt(event.target.getAttribute('data-index'));
				context.editCart(cart.items[_index], 0, false);
			}
					
			let modalClass = 'c-cart c-cart--step-' + cartStep;
			if (cartOpen === true) {
				modalClass = 'c-cart state-cart-active c-cart--step-' + cartStep;
			}
			
			let total = 0;
			if (cart.items) {
				for (let j=0;j<cart.items.length;j++) {
					total += cart.items[j].price * cart.items[j].qty;  
				}
			}
			
			let orderNotes = '';
			let deliveryNotes = '';
	
			return (
				<div className={modalClass}>
					<a href="#" className="c-cart__overlay" onClick={toggleCart}></a>
					<form className="c-cart__panel" onSubmit={submitOrder}>
						<div className="c-cart__panel__step">
							<a href="#" className="c-cart__close" onClick={toggleCart}></a>
							<h3 className="c-cart__heading">Quote Request</h3>
							<h4 className="c-cart__subheading">Review product selection</h4>
							<table className="c-cart__items">
								<tbody>
									<tr className="c-cart__item c-cart__item--header">
										<th className="c-cart__item__cell c-cart__item__cell--th">Product</th>
										<th className="c-cart__item__cell c-cart__item__cell--th">Price</th>
										<th className="c-cart__item__cell c-cart__item__cell--th">Qty</th>
										<th className="c-cart__item__cell c-cart__item__cell--th">Total</th>
										<th className="c-cart__item__cell c-cart__item__cell--th">&nbsp;</th>
									</tr>
									{cart.items &&
										<CartRows></CartRows>
									}
								</tbody>
							</table>
							<div className="c-cart__order-footer">
								<textarea className="c-cart__notes" onChange={event => (orderNotes = event.target.value)} placeholder="Order Notes">{orderNotes}</textarea>
								{cart.items &&
									<div className="c-cart__order-footer__total">
										<h5 className="c-cart__total-header">Estimated Total</h5>
										<p className="c-cart__total-header">${ Intl.NumberFormat().format(total) } .Ex GST</p>
										<small className="c-cart__total-header c-cart__total-header--small">Excludes shipping</small>
										<a href="#" className="c-cart__continue" onClick={toggleCart}>Continue Shopping</a>
										<a href="#" className="c-cart__next" onClick={cartNext}>Next</a>
									</div>
								}
							</div>	
						</div>
						<div className="c-cart__panel__step">
							<a href="#" className="c-cart__close" onClick={toggleCart}></a>
							<h3 className="c-cart__heading">Quote Request</h3>
							<h4 className="c-cart__subheading">Shipping & Delivery</h4>
							<div className="c-cart__shipping scope-form">
								<div className="c-cart__shipping__left">
									<div className="form-fields">
										<div className="form-field">
											<FirstName></FirstName>
										</div>
										<div className="form-field">
											<LastName></LastName>
										</div>
										<div className="form-field">
											<Phone></Phone>
										</div>
										<div className="form-field">
											<StreetAddress></StreetAddress>
										</div>
										<div className="form-field">
											<City></City>
										</div>
										<div className="form-field">
											<State></State>
										</div>
										<div className="form-field">
											<Postcode></Postcode>
										</div>
									</div>
								</div>
								<textarea className="c-cart__delivery" onChange={event => (deliveryNotes = event.target.value)} placeholder="Delivery Notes">{deliveryNotes}</textarea>
							</div>
							<div className="c-cart__shipping-footer">
								<a href="#" className="c-cart__back" onClick={cartPrev}>Back</a>
								<input className="c-cart__submit" type="submit" value="Submit" />
							</div>
						</div>
						<div className="c-cart__panel__step">
							<a href="#" className="c-cart__close" onClick={toggleCart}></a>
							<h3 className="c-cart__heading">Quote Request</h3>
							<h4 className="c-cart__subheading">Successfully Created</h4>
							<div className="c-cart__thanks scope-text scope-text--center" dangerouslySetInnerHTML={ {__html: '<p>Thank you for submitting your quote request with Bloomingdales. One of our team members will be in touch within the next 24 hours with a formal quotation. If you have any questions in the meantime, please do not hesitate to contact us at info@bloomingdales.com.au</p>' } }>
								
							</div>
						</div>
					</form>
				</div>
			)
		}
		
	} else {
		
		return null;
	}

}
export default WithConsumer(CartModal);